import * as React from 'react'
import { INPUT_CONFIG } from '../Constants'
import * as Checkbox from './Checkbox'
import * as CheckboxGroup from './CheckboxGroup'
import * as Combobox from './Combobox'
import * as Heading from './Heading'
import * as Input from './Input'
import * as Numeric from './Numeric'
import * as Radio from './Radio'
import * as Select from './Select'
import * as TextArea from './TextArea'

export const FormRendererSwitcher = props => {
  const inputType = props.input.type

  switch (inputType) {
    case INPUT_CONFIG.input.type:
      return <Input.Form {...props} />
    case INPUT_CONFIG.numeric.type:
      return <Numeric.Form {...props} />
    case INPUT_CONFIG.combobox.type:
      return <Combobox.Form {...props} />
    case INPUT_CONFIG.select.type:
      return <Select.Form {...props} />
    case INPUT_CONFIG.radio.type:
      return <Radio.Form {...props} />
    case INPUT_CONFIG.checkbox.type:
      return <Checkbox.Form {...props} />
    case INPUT_CONFIG.checkboxGroup.type:
      return <CheckboxGroup.Form {...props} />
    case INPUT_CONFIG.textarea.type:
      return <TextArea.Form {...props} />
    case INPUT_CONFIG.heading.type:
      return <Heading.Form {...props} />
    default:
      return null
  }
}

export const ConfigurationRendererSwitcher = props => {
  const inputType = props.input.type

  switch (inputType) {
    case INPUT_CONFIG.input.type:
      return <Input.Configuration {...props} />
    case INPUT_CONFIG.numeric.type:
      return <Numeric.Configuration {...props} />
    case INPUT_CONFIG.select.type:
      return <Select.Configuration {...props} />
    case INPUT_CONFIG.combobox.type:
      return <Combobox.Configuration {...props} />
    case INPUT_CONFIG.radio.type:
      return <Radio.Configuration {...props} />
    case INPUT_CONFIG.checkbox.type:
      return <Checkbox.Configuration {...props} />
    case INPUT_CONFIG.checkboxGroup.type:
      return <CheckboxGroup.Configuration {...props} />
    case INPUT_CONFIG.textarea.type:
      return <TextArea.Configuration {...props} />
    case INPUT_CONFIG.heading.type:
      return <Heading.Configuration {...props} />
    default:
      return null
  }
}
